export const NAVBAR_SHOW_SPINNER = 'NAVBAR_SHOW_SPINNER'
export const NAVBAR_HIDE_SPINNER = 'NAVBAR_HIDE_SPINNER'
export const NAVBAR_SHOW_SLOW_SPINNER = 'NAVBAR_SHOW_SLOW_SPINNER'
